const API_URL = process.env.REACT_APP_CARDS;

export async function updateNodePosition(authFetch, nodeId, x_axis, y_axis) {
  try {
    const response = await authFetch(`${API_URL}${nodeId}/`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ x_axis, y_axis }),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Failed to update node position: ${text}`);
    }

    return await response.json();
  } catch (error) {
    console.error('updateNodePosition error:', error);
    throw error;
  }
}
